import { OutlineElement } from '../../base/outline-element/outline-element';
import { CSSResultGroup, html, TemplateResult, nothing } from 'lit';
import { customElement, state, property } from 'lit/decorators.js';
import componentStyles from './ghs-event-detail-item.css.lit';
import { ghsCreditCards } from '../ghs-event-detail/ghs-event-detail-assets';

/**
 * The Event Detail Item component
 *
 * @element ghs-event-detail
 * @slot title - Contains title content.
 * @slot price - Contains price tag.
 * @slot defaultSlot - Contains the content.
 */
@customElement('ghs-event-detail-item')
export class GhsEventDetailItem extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * Renders the payment options
   * @param renderPayment boolean
   * @default true
   */
  @property({ type: Boolean, attribute: 'render-payment', reflect: true })
  renderPayment = false;

  @state() hasTitleSlot = false;
  @state() hasPriceSlot = false;

  firstUpdated(): void {
    super.firstUpdated();
    this.hasTitleSlot = this.querySelector('[slot="title"]') !== null;
    this.hasPriceSlot = this.querySelector('[slot="price"]') !== null;
  }
  render(): TemplateResult {
    return html`
      <div class="event-detail-item">
        ${this.hasTitleSlot ? html`<slot name="title"></slot>` : nothing}
        ${this.hasPriceSlot ? html`<slot name="price"></slot>` : nothing}
        <div class="event-detail-content">
          <slot></slot>
          ${this.renderPayment
            ? html`<div class="cards">${ghsCreditCards}</div>`
            : nothing}
        </div>
      </div>
    `;
  }
}
